export const CONCEPTS = {
  ALL_UL: "allUl",
  TERM: "term_concept",
};
